import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaInnerLoading from './VaInnerLoading.vue'

export default withConfigTransport(VaInnerLoading)
